import { createReducer, on } from '@ngrx/store';
import * as GroupListActions from './Grouplist.action';

export interface GroupListState {
  groups: any[];
  loading: boolean;
  error: any;
}

export const initialGroupListState: GroupListState = {
  groups: [],
  loading: false,
  error: null
};

export const groupListReducer = createReducer(
  initialGroupListState,
  on(GroupListActions.loadGroupList, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(GroupListActions.loadGroupListSuccess, (state, { groups }) => ({
    ...state,
    groups,
    loading: false,
    error: null
  })),
  on(GroupListActions.loadGroupListFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);
